<template>
  <div style="display:inline-block">
    <el-select style="width:100%"
      v-model="tagType"
      v-if="status==='select'"
      placeholder="请选择标签"
      @change="handleChange">
      <el-option v-if="showAll"
        label="全部"
        :value="''"></el-option>
      <el-option v-for="item in tagTypeList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <span v-else>{{tagName}}</span>
  </div>

</template>

<script>
import BaseData from '@/utils/baseData'
import _ from 'lodash'
export default {
  name: 'vendor-label-select',
  components: {},
  props: {
    status: {
      type: String,
      default: 'select'
    },
    showAll: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object
    }
  },
  data () {
    return {
      tagTypeList: [],
      tagName: ''
    }
  },
  watch: {
    'option.vendorId': {
      handler (val, oldVal) {
        if (val && val !== oldVal) {
          this.fetchList()
        }
      },
      immediate: true
    }
  },
  computed: {
    tagType: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.tagName = (_.find(this.tagTypeList, o => o.value === val) || {}).label
      }
    }
  },
  methods: {
    handleChange () {
      this.callback && this.callback()
    },
    fetchList () {
      this.$store.dispatch('vendor/getvendortagtypes', {
        payload: this.option,
        success: (res) => {
          let tagTypes = res.data.tagTypes
          this.tagTypeList = BaseData.tags.filter(item => tagTypes.indexOf(+item.value) > -1)
          this.tagName = (_.find(this.tagTypeList, o => o.value === this.tagType) || {}).label
        },
        fail: () => {
          this.tagTypeList = []
          this.tagName = ''
        }
      })
    }
  }
}
</script>
